<template>
  <payment-result-success-layout
    :title="title"
    :subtitle="subtitle"
    :icon="icon"
    :footer-path="footeri18nPath"
  >
    <template
      v-if="subscriptionState.active"
      #footer-content
    >
      <span class="font-weight-medium">
        {{ subscriptionInfo.paidUntil }}
      </span>
      <span>
        <span class="font-weight-medium">{{ $t('title.settings') }}</span> →
        <span class="font-weight-medium">{{ $t('title.account') }}</span>  →
        <span class="font-weight-medium">{{ $t('title.billing') }}</span>
      </span>
    </template>
  </payment-result-success-layout>
</template>

<script setup lang="ts">

import {
  PropType, computed,
} from 'vue';
import { SubscriptionInfo } from '@/services/billing-utils';
import i18n from '@/plugins/i18n';
import PaymentResultSuccessLayout from './PaymentResultSuccessLayout.vue';

const props = defineProps({
  subscriptionInfo: { type: Object as PropType<SubscriptionInfo>, required: true },
});

const subscriptionState = computed(() => {
  if (props.subscriptionInfo.active) return { active: true };
  if (props.subscriptionInfo.awaitingPayment) return { awaitingPayment: true };
  return { error: true };
});

const title = computed(() => {
  if (subscriptionState.value.active) { return i18n.t('label.thank_you'); }
  if (subscriptionState.value.awaitingPayment) { return i18n.t('label.payment_processing'); }
  return i18n.t('label.oops');
});

const subtitle = computed(() => {
  if (subscriptionState.value.active) { return i18n.t('label.your_subscription_is_active'); }
  if (subscriptionState.value.awaitingPayment) { return i18n.t('message.payment_processing'); }
  return i18n.t('error.billing_general');
});

const icon = computed(() => {
  if (subscriptionState.value.active) { return 'mdi-checkbox-marked-circle'; }
  if (subscriptionState.value.awaitingPayment) { return 'mdi-alert'; }
  return 'mdi-alert';
});

const footeri18nPath = computed(() => {
  if (!subscriptionState.value.active) return 'message.billing_method_setup';
  return props.subscriptionInfo.sentInvoice
    ? 'message.billing_subscription_invoice_sent_on' : 'message.billing_subscription_renewed_on';
});

</script>
